(function ($, site) {
  Drupal.behaviors.ProductComparisonV1 = {
    attached: false,
    isMobile: false,
    nodes: {},

    selectors: {
      container: '.js-product-comparison',
      productWrapper: '.js-product-comparison-content',
      pinnedWrapper: '.js-product-comparison__products-pinned',
      productItem: '.js-product-comparison-grid-item',
      productName: '.js-product-comparison__product-name',
      productDescription: '.js-product-comparison__description',
      productBenefit: '.js-product-comparison__benefit',
      productHairtype: '.js-product-comparison__hairtype'
    },
    pinFirstProduct: function ($productsWrapper) {
      var self = this;
      var $pinnedWrapper = $productsWrapper.find(
        self.selectors.pinnedWrapper
      );
      var $carousel = $productsWrapper.find(
        self.selectors.productWrapper
      );
      var $firstItem = $carousel.find(
        self.selectors.productItem
      ).first();

      if (!$firstItem.length) {
        return;
      }
      $firstItem.find('a').attr('href', '#').addClass('disabled');
      $firstItem.appendTo($pinnedWrapper);
    },
    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }
      self.attached = true;
      self.setup($(context));
    },

    setup: function ($that) {
      var self = this;
      var bps = Unison.fetch.all();
      var bp = Unison.fetch.now();

      self.isMobile = parseInt(bp.width, 10) < parseInt(bps.landscape, 10);
      self.getDom($that);
      self.setCarousel($that);
    },

    getDom: function ($that) {
      var self = this;

      $that.nodes = {};
      $that.nodes.$container = $(self.selectors.container, $that);
      $that.nodes.$productWrapper = $(self.selectors.productWrapper, $that.nodes.$container);
      $that.nodes.$productName = $(self.selectors.productName, $that.nodes.$container);
      $that.nodes.$productDescription = $(
        self.selectors.productDescription,
        $that.nodes.$container
      );
      $that.nodes.$productBenefit = $(
        self.selectors.productBenefit,
        $that.nodes.$container
      );
      $that.nodes.$productHairtype = $(
        self.selectors.productHairtype,
        $that.nodes.$container
      );
    },
    setCarousel: function ($that) {
      var self = this;
      var bps = Unison.fetch.all();

      $that.nodes.$productWrapper.each(function () {
        var $carousel = $(this);
        var $arrowsDiv = $that.nodes.$container.find('.js-product-comparison-carousel-controls');
        var $dotsDiv = $that.nodes.$container.find('.js-product-comparison-carousel-dots');
        var $productsWrapper = $carousel.closest(
          '.js-product-comparison__products'
        );

        self.pinFirstProduct($productsWrapper);
        var settings = {
          infinite: false,
          slidesToShow: 1,
          dots: true,
          appendDots: $dotsDiv,
          mobileFirst: true,
          draggable: true,
          arrows: true,
          appendArrows: $arrowsDiv,
          swipe: true,
          waitForAnimate: false,
          responsive: [
            {
              breakpoint: parseInt(bps.landscape, 10) - 1,
              settings: {
                dots: true,
                appendDots: $dotsDiv,
                slidesToShow: 3,
                slidesToScroll: 1,
                initialSlide: 0
              }
            }
          ]
        };

        $carousel
          .once()
          .on('breakpoint', function (event, slick) {
            var bp = Unison.fetch.now();
            var isMobile = parseInt(bp.width, 10) < parseInt(bps.landscape, 10);

            if (isMobile === self.isMobile) {
              return;
            }

            self.isMobile = isMobile;
          });

        $carousel.slick(settings);
      });
    },
  };
})(jQuery, window.site);
